import { render, staticRenderFns } from "./PlatformTicketsDrawer.vue?vue&type=template&id=1d3313b4&scoped=true&lang=pug&"
import script from "./PlatformTicketsDrawer.vue?vue&type=script&lang=js&"
export * from "./PlatformTicketsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTicketsDrawer.vue?vue&type=style&index=0&id=1d3313b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3313b4",
  null
  
)

/* custom blocks */
import block0 from "./PlatformTicketsDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports